const prefix = 'PHARMACIES_';

export const PharmaciesActionTypes = {
  SET_INITIAL_STORE: `${prefix}SET_INITIAL_STORE`,
  SET_HASHED_PHARMACY_ID: `${prefix}SET_HASHED_PHARMACY_ID`,
  SET_DESCRIPTION: `${prefix}SET_DESCRIPTION`,
  SET_PHARMACY_FILE: `${prefix}SET_PHARMACY_FILE`,
  SET_PHARMACY_TEXT: `${prefix}SET_PHARMACY_TEXT`,
  SET_SELECTED_GENDER: `${prefix}SET_SELECTED_GENDER`,
  SET_APPLICANT_NAME: `${prefix}SET_APPLICANT_NAME`,
  SET_APPLICANT_LAST_NAME: `${prefix}SET_APPLICANT_LAST_NAME`,
  SET_APPLICANT_CODE: `${prefix}SET_APPLICANT_CODE`,
  SET_RECIPIENTS_LIST: `${prefix}SET_RECIPIENTS_LIST`,
  SET_CLIENT_SUGGESTED_TYPE: `${prefix}SET_CLIENT_SUGGESTED_TYPE`,
  SET_CLIENT_SUGGESTED_TIME: `${prefix}SET_CLIENT_SUGGESTED_TIME`,
  SET_CLIENT_SUGGESTED_RANGE: `${prefix}SET_CLIENT_SUGGESTED_RANGE`,
  CHECK_DATA_VALIDATION: `${prefix}CHECK_DATA_VALIDATION`,
  STORE_UPLOAD_PHARMACY_DATA: `${prefix}STORE_UPLOAD_PHARMACY_DATA`,
  SET_CLIENT_INFO: `${prefix}SET_CLIENT_INFO`,
  SET_STORE_LOADING: `${prefix}SET_STORE_LOADING`,
  SET_NEW_DRUG: `${prefix}SET_NEW_DRUG`,
  DELETE_SELECTED_DRUG: `${prefix}DELETE_SELECTED_DRUG`,
  SET_DRUG_INFO: `${prefix}SET_DRUG_INFO`,
  STORE_OTC_PHARMACY_DATA: `${prefix}STORE_OTC_PHARMACY_DATA`,
  CHECK_CARD_VALIDATION: `${prefix}CHECK_CARD_VALIDATION`,
  SET_EDIT_IMAGE_FILE: `${prefix}SET_EDIT_IMAGE_FILE`,
  GET_EDIT_IMAGE_FILE: `${prefix}GET_EDIT_IMAGE_FILE`,
  INSERT_DRUG_IMAGE: `${prefix}INSERT_DRUG_IMAGE`,
  SET_IMAGE_INITIAL: `${prefix}SET_IMAGE_INITIAL`,
  NEXT_STEP_VALIDATION: `${prefix}NEXT_STEP_VALIDATION`,
  SET_NEW_DRUG_VALIDATION: `${prefix}SET_NEW_DRUG_VALIDATION`,
  SET_TOP_SALE_DRUG: `${prefix}SET_TOP_SALE_DRUG`,
  HANDLE_LOCK_CARD: `${prefix}HANDLE_LOCK_CARD`,
  SET_LOCK_CARD: `${prefix}SET_LOCK_CARD`,
  SET_PHARMACY_OTC_FOR_VALIDATION: `${prefix}SET_PHARMACY_OTC_FOR_VALIDATION`,
  ENABLE_COMPLETE_ORDER: `${prefix}ENABLE_COMPLETE_ORDER`,
  DISABLE_COMPLETE_ORDER: `${prefix}DISABLE_COMPLETE_ORDER`,
  SET_RESIDENCE_CITY: `${prefix}SET_RESIDENCE_CITY`,
  SET_QUERY_DRUG: `${prefix}SET_QUERY_DRUG`,
  SET_CITY_MODAL: `${prefix}SET_CITY_MODAL`,
  SET_CITY_HREF: `${prefix}SET_CITY_HREF`,
  HANDLE_CARD_VALIDATION: `${prefix}HANDLE_CARD_VALIDATION`,
  SET_CHECK_DRUG_LOADING: `${prefix}SET_CHECK_DRUG_LOADING`,

  PHARMACY_DATA_VALIDATION: `${prefix}PHARMACY_DATA_VALIDATION`,
  OTC_DATA_VALIDATION: `${prefix}OTC_DATA_VALIDATION`,
  PRESCRIPTION_DATA_VALIDATION: `${prefix}PRESCRIPTION_DATA_VALIDATION`,
  SET_PHARMACY_LOADING: `${prefix}SET_PHARMACY_LOADING`,
  SET_ELECTRONIC_PRESCRIPTION: `${prefix}SET_ELECTRONIC_PRESCRIPTION`,
  GET_INSURANCE_LIST: `${prefix}GET_INSURANCE_LIST`,
  SET_INSURANCE_LIST: `${prefix}SET_INSURANCE_LIST`,
  CHECK_ELECTRONIC_VALIDATION: `${prefix}CHECK_ELECTRONIC_VALIDATION`,
  STORE_ELECTRONIC_PHARMACY_DATA: `${prefix}STORE_ELECTRONIC_PHARMACY_DATA`,
  SET_OTC_STORAGE_DATA: `${prefix}SET_OTC_STORAGE_DATA`,
  GET_PHARMACY_BANNER: `${prefix}GET_PHARMACY_BANNER`,
  SET_PHARMACY_BANNER: `${prefix}SET_PHARMACY_BANNER`,
  SET_CONSULT_PRESCRIPTION: `${prefix}SET_CONSULT_PRESCRIPTION`,
  SET_OTC_QUERY_DATA: `${prefix}SET_OTC_QUERY_DATA`,
};

const setInitialStore = () => ({ type: PharmaciesActionTypes.SET_INITIAL_STORE });
const setHashedPharmacyId = (data: { hashedPharmacyId: string }) => ({ type: PharmaciesActionTypes.SET_HASHED_PHARMACY_ID, data: data });
const setDescription = (data: { selectedServiceDescription: any }) => ({ type: PharmaciesActionTypes.SET_DESCRIPTION, data: data });
const setPharmacyFile = (data: { pharmacyFile: any }) => ({ type: PharmaciesActionTypes.SET_PHARMACY_FILE, data: data });
const setPharmacyText = (data: { pharmacyText: string }) => ({ type: PharmaciesActionTypes.SET_PHARMACY_TEXT, data: data });
const setGender = (data: { gender: string }) => ({ type: PharmaciesActionTypes.SET_SELECTED_GENDER, data: data });
const setApplicantName = (data: { applicantName: string }) => ({ type: PharmaciesActionTypes.SET_APPLICANT_NAME, data: data });
const setApplicantLastName = (data: { applicantLastName: string }) => ({ type: PharmaciesActionTypes.SET_APPLICANT_LAST_NAME, data: data });
const setApplicantCode = (data: { applicantCode: string }) => ({ type: PharmaciesActionTypes.SET_APPLICANT_CODE, data: data });
const setRecipientsList = (data: { id: string, text: string, recipientsValidation: boolean }) => ({ type: PharmaciesActionTypes.SET_RECIPIENTS_LIST, data: data });
const setClientSuggestedType = (data: { clientSuggestedType: string }) => ({ type: PharmaciesActionTypes.SET_CLIENT_SUGGESTED_TYPE, data: data });
const setClientSuggestedTime = (data: { clientSuggestedTime: string }) => ({ type: PharmaciesActionTypes.SET_CLIENT_SUGGESTED_TIME, data: data });
const setClientSuggestedRange = (data: { clientSuggestedRange: string }) => ({ type: PharmaciesActionTypes.SET_CLIENT_SUGGESTED_RANGE, data: data });
const storeUploadPharmacyData = () => ({ type: PharmaciesActionTypes.STORE_UPLOAD_PHARMACY_DATA });
const checkDataValidation = () => ({ type: PharmaciesActionTypes.CHECK_DATA_VALIDATION });
const setNewDrug = () => ({ type: PharmaciesActionTypes.SET_NEW_DRUG });
const deleteSelectedDrug = (data: { key: string }) => ({ type: PharmaciesActionTypes.DELETE_SELECTED_DRUG, data: data });
const setDrugInfo = (data: { info: string | boolean | number, key: string, id: string }) => ({ type: PharmaciesActionTypes.SET_DRUG_INFO, data: data });
const storeOtcPharmacyData = () => ({ type: PharmaciesActionTypes.STORE_OTC_PHARMACY_DATA });
const checkCardValidation = () => ({ type: PharmaciesActionTypes.CHECK_CARD_VALIDATION });
const getEditImageFile = (data: { pharmacyEditedImage: File | Blob, pharmacyEditedImageIndex: number }) => ({ type: PharmaciesActionTypes.GET_EDIT_IMAGE_FILE, data: data });
const setEditImageFile = (data: { pharmacyEditedImage: File | Blob }) => ({ type: PharmaciesActionTypes.SET_EDIT_IMAGE_FILE, data: data });
const nextStepValidation = () => ({ type: PharmaciesActionTypes.NEXT_STEP_VALIDATION });
const setNewDrugValidation = () => ({ type: PharmaciesActionTypes.SET_NEW_DRUG_VALIDATION });
const setTopSaleDrug = (data: { name: string, unit: number, type: number }) => ({ type: PharmaciesActionTypes.SET_TOP_SALE_DRUG, data: data });
const handleLockCard = (data: { id: string }) => ({ type: PharmaciesActionTypes.HANDLE_LOCK_CARD, data: data });
const enableCompleteOrder = () => ({ type: PharmaciesActionTypes.ENABLE_COMPLETE_ORDER });
const setResidenceCity = (data: { id: string | undefined, name: string | undefined, title: string | undefined }) => ({ type: PharmaciesActionTypes.SET_RESIDENCE_CITY, data: data });
const setQueryDrug = (data: { name: string, type: number }) => ({ type: PharmaciesActionTypes.SET_QUERY_DRUG, data: data });
const setCityModal = (data: {open: boolean, type?: 'otc' | 'prescription' | 'electronicPrescription'}) => ({ type: PharmaciesActionTypes.SET_CITY_MODAL, data: data });
const setCityHref = (data: {href: string}) => ({ type: PharmaciesActionTypes.SET_CITY_HREF, data: data });
const pharmacyDataValidation = (data: {type?: 'otc' | 'prescription' | 'electronicPrescription'}) => ({ type: PharmaciesActionTypes.PHARMACY_DATA_VALIDATION, data: data });
const setElectronicPrescription = (data : {key: string, data: string}) => ({ type: PharmaciesActionTypes.SET_ELECTRONIC_PRESCRIPTION, data: data });
const getInsuranceList = () => ({ type: PharmaciesActionTypes.GET_INSURANCE_LIST });
const checkElectronicValidation = () => ({ type: PharmaciesActionTypes.CHECK_ELECTRONIC_VALIDATION });
const storeElectronicPharmacyData = () => ({ type: PharmaciesActionTypes.STORE_ELECTRONIC_PHARMACY_DATA });
const setOtcStorageData = (data: {otcList: Array<any>}) => ({ type: PharmaciesActionTypes.SET_OTC_STORAGE_DATA, data: data });
const getPharmacyBanner = () => ({ type: PharmaciesActionTypes.GET_PHARMACY_BANNER });
const setOtcQueryData = (data: {name: string, unit: string, quantity: string, type: string}) => ({ type: PharmaciesActionTypes.SET_OTC_QUERY_DATA, data: data });

export const PharmaciesActions = {
  setInitialStore: setInitialStore,
  setHashedPharmacyId: setHashedPharmacyId,
  setDescription: setDescription,
  setPharmacyFile: setPharmacyFile,
  setPharmacyText: setPharmacyText,
  setGender: setGender,
  setApplicantName: setApplicantName,
  setApplicantLastName: setApplicantLastName,
  setApplicantCode: setApplicantCode,
  setRecipientsList: setRecipientsList,
  setClientSuggestedType: setClientSuggestedType,
  setClientSuggestedTime: setClientSuggestedTime,
  setClientSuggestedRange: setClientSuggestedRange,
  storeUploadPharmacyData: storeUploadPharmacyData,
  checkDataValidation: checkDataValidation,
  setNewDrug: setNewDrug,
  deleteSelectedDrug: deleteSelectedDrug,
  setDrugInfo: setDrugInfo,
  storeOtcPharmacyData: storeOtcPharmacyData,
  checkCardValidation: checkCardValidation,
  getEditImageFile: getEditImageFile,
  setEditImageFile: setEditImageFile,
  nextStepValidation: nextStepValidation,
  setNewDrugValidation: setNewDrugValidation,
  setTopSaleDrug: setTopSaleDrug,
  handleLockCard: handleLockCard,
  enableCompleteOrder: enableCompleteOrder,
  setResidenceCity: setResidenceCity,
  setQueryDrug: setQueryDrug,
  setCityModal: setCityModal,
  setCityHref: setCityHref,
  pharmacyDataValidation: pharmacyDataValidation,
  setElectronicPrescription: setElectronicPrescription,
  getInsuranceList: getInsuranceList,
  checkElectronicValidation: checkElectronicValidation,
  storeElectronicPharmacyData: storeElectronicPharmacyData,
  setOtcStorageData: setOtcStorageData,
  getPharmacyBanner: getPharmacyBanner,
  setOtcQueryData: setOtcQueryData,
};
